<template>
    <!-- no disapprovals -->
    <div class="no-disapprovals-empty-state">
        <DisapprovalsCheck />
        <Text size="f-8"><b>0</b> {{ disapprovalType }} with outstanding disapprovals.</Text>
    </div>
</template>

<script lang="ts" setup>
import { Text, Spacer } from '@opteo/components-next'
import DisapprovalsCheck from './DisapprovalsCheck.vue'

const props = defineProps<{
    disapprovalType: string
}>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.no-disapprovals-empty-state {
    @include container;
    @include flex;
    @include items-center;
    @include justify-center;
    @include ph-24;
    @include pv-32;
    @include br-20;
    gap: 0.75rem;
}
</style>
